<template>
  <div>
    <ckeditor
      v-model="editorData"
      :editor-url="editorUrl"
      :config="editorConfig"
    ></ckeditor>
    <textarea
      :name="name"
      :value="editorData"
      style="display: none;"
    ></textarea>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
    value: {
      required: false,
      default: '',
    },
  },
  data() {
    return {
      editorData: this.value,
      editorUrl: '/vendor/ckeditor/ckeditor.js',
      resize_minHeight: 1000,
      editorConfig: {
        toolbar: [
          ['Bold', 'Italic'],
          ['BulletedList', 'NumberedList'],
          ['Link'],
        ],
      },
    };
  },
};
</script>

<style>
.ck-editor__editable {
  min-height: 200px;
}
</style>
